import axios from 'axios';
import jwt from 'modules/jwt';
import * as R from 'ramda';

import { serializedBrandingUrl, setWindowObject, windowObject, windowLang } from './utils';

let jwtGet;
let jwtPost;
let tokenUrl = '';
let companyConfig;

const unnest = R.path(['data', 'data']);
const jwtGetSafe = url => {
  return jwtGet ? jwtGet(url) : hubConfig().then(() => jwtGetSafe(url));
};

const jwtPostSafe = (url, data, additional_headers) => {
  return jwtPost ? jwtPost.post(url, data) : hubConfig(additional_headers).then(() => jwtPostSafe());
};

const createJwtGet = (shouldLogOut = true) => {
  let headers = {
    'X_ORG_ID': companyConfig.hub.id
  };

  if (windowObject) {
    headers = { ...headers, 'Accept-Language': windowLang() };
  }

  jwtGet = jwt(axios.create({
    withCredentials: true,
    baseURL: companyConfig.api.url,
    headers
  }), axios, companyConfig.hub.tokenUrl, shouldLogOut);
};

const createJwtPost = (additional_headers = {}) => {
  let headers = {
    ...additional_headers,
    'X_ORG_ID': companyConfig.hub.id
  };

  if (windowObject) {
    headers = { ...headers, 'Accept-Language': windowLang() };
  }

  jwtPost = jwt(axios.create({
    withCredentials: true,
    baseURL: companyConfig.api.url,
    headers
  }), axios, companyConfig.hub.tokenUrl);
};

export const windowObjectApi = () => {
  if (windowObject) return Promise.resolve(true);

  return jwtGetSafe('api/c2_homepage/infl_window_object').then(R.pipe(
    R.prop('data'),
    setWindowObject,
    createJwtGet
  ));
};

export const hubConfig = (additional_headers = {}, shouldLogOut = true) => axios.get('/api/company_config').then(config => {
  companyConfig = unnest(config);
  tokenUrl = companyConfig.hub.tokenUrl;

  createJwtGet(shouldLogOut);
  createJwtPost(additional_headers);

  return companyConfig.hub.allowOpenSignUp;
});

export const getToken = () => axios.post(tokenUrl, null, {
  withCredentials: true,
  headers: { 'Accept': 'application/jwt', 'X-Requested-With': 'XMLHttpRequest' }
});

export const publicHomepageTabs = () => axios.get('/api/public_homepage_tabs').then(unnest);
export const features = () => jwtGetSafe('/api/advocate_links').then(unnest);
export const profile = () => jwtGetSafe('/people/self').then(unnest);
export const messageCount = () => jwtGetSafe('/conversations/counts');
export const hubSwitcher = () => jwtGetSafe('/hub_switcher')
  .then(unnest)
  .then(R.merge({ family: { companies: [] } }));
export const notificationsCount = () => jwtGetSafe('/api/notifications/unread_count').then(({ data }) => data);
export const enabledFeatures = () => axios.get('/api/features/public').then(unnest);
export const unseenDiscussionsCounts = companyIds => {
  return jwtGetSafe(`/api/unseen/discussions?company_ids=${JSON.stringify(companyIds)}`).then(({ data }) => data);
};
export const unseenChallengesCounts = companyIds => {
  return jwtGetSafe(`/api/unseen/challenges?company_ids=${JSON.stringify(companyIds)}`).then(({ data }) => data);
};

export const customBranding = () => {
  const brandingUrl = serializedBrandingUrl();

  if (brandingUrl) return axios.get(brandingUrl).then(R.prop('data'));

  return axios.get('/api/branding').then(unnest);
};

export const editProfile = () => jwtGetSafe('/api/current_contact/edit').then(R.prop('data'));
export const updateProfile = (data) => jwtPostSafe('/api/current_contact/', data, { 'Content-Type': 'multipart/mixed' }).then(R.prop('data'));